/* HILO — remove the auto "All" button from the Editions row.

   The Explore section builds its own "All" button from whatever collection the
   category circle points at:

       '<button class="hilo-style" data-target="' + main + '">All</button>'

   For every garment category that is right — All Kurta, All Shirts. But the
   Editions circle points at the newest edition (Sambaram), so its "All" shows
   only Sambaram, sitting next to a "Sambaram" button that does exactly the
   same thing. Two buttons, one result.

   Why a script and not CSS: CSS cannot match an element by its text, and the
   button carries no class of its own. The row is also rebuilt from scratch
   every time a category is clicked, so a one-time removal would not survive.
   This watches the row and prunes after each render.

   Only Editions is touched. Every other category keeps its All button.
*/
(function () {
  if (window.__hiloEditionsNoAll) return;
  window.__hiloEditionsNoAll = true;

  /* Must match the handle on the Editions block. See hilo-cat-editions.css —
     both files key off this, so they change together when a new edition
     becomes the default. */
  var EDITION_HANDLE = 'sambaram';

  function prune(row) {
    if (!row) return;

    /* Only when Editions is the selected category. */
    var active = document.querySelector('.hilo-cat.is-active');
    if (!active || active.getAttribute('data-handle') !== EDITION_HANDLE) return;

    var btns = row.querySelectorAll('.hilo-style');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (b.getAttribute('data-target') !== EDITION_HANDLE) continue;
      if (b.textContent.trim().toLowerCase() !== 'all') continue;

      var wasActive = b.classList.contains('is-active');
      b.parentNode.removeChild(b);

      /* If All was the highlighted one, hand the highlight to the button that
         now leads the row — otherwise nothing looks selected. */
      if (wasActive) {
        var first = row.querySelector('.hilo-style');
        if (first) first.classList.add('is-active');
      }
      break;
    }
  }

  function watch(row) {
    if (!row || row.dataset.hiloNoall) return;
    row.dataset.hiloNoall = '1';
    /* The section replaces this row's innerHTML on every category change. */
    new MutationObserver(function () { prune(row); }).observe(row, { childList: true });
    prune(row);
  }

  function scan() {
    var rows = document.querySelectorAll('.hilo-explore__styles');
    for (var i = 0; i < rows.length; i++) watch(rows[i]);
  }

  scan();
  document.addEventListener('shopify:section:load', scan);

  /* Catch the row if the section renders after this script runs. */
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1 && added[j].querySelector) scan();
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();